import React from "react"
import Axios from 'axios'
import CambistaTemplate from "./CambistaTemplate"
import moment from 'moment';
import { Link } from 'react-router-dom';

export class CaixaCambista extends React.Component {
    constructor(props) {
        super(props)
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            saidas: 0,
            entradas: 0,
            comissao: 0,
            transacoes: []
        }
        this.listarTransacoes()
        this.criarTransacao = this.criarTransacao.bind(this)
    }


    formatDate(data) {
        return moment(data).add(0, 'days').format('DD-MM-YYYY')
    }

    getUser = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            })
            const response = await axiosInstance.post("usuarios/user", {
                id: this.state.user._id
            })

            window.localStorage.setItem("user", JSON.stringify(response.data[0]))
            this.setState({ user: response.data[0] })
        } catch (err) {
            console.log(err)
        }
    }

    listarTransacoes = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            })
            const response = await axiosInstance.post("transacoes/por-user", {
                userId: this.state.user._id
            })
            this.setState({ transacoes: response.data })
            this.gerarSaldos()
        } catch (err) {
            console.log(err)
        }
    }

    gerarSaldos() {
        this.state.transacoes.map(item => {
            if (item.tipo == "Venda") {
                this.setState({ comissao: this.state.comissao + item.taxaComissao })
                if (item.emissorId._id != this.state.user._id) {
                    this.setState({ entradas: this.state.entradas + item.valor })
                } else if (item.emissorId._id == this.state.user._id) {
                    this.setState({ saidas: this.state.saidas + item.valor })
                }
            }

        })


    }

    async criarTransacao() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            })
            const response = await axiosInstance.post(
                "transacoes/criar-transacao",
                {
                    data: new Date(),
                    documento: "",
                    valor: this.state.entradas - this.state.comissao,
                    emissorId: this.state.user._id,
                    receptorId: this.state.user.tutorId,
                    tipo: "Pagamento",
                    observacao: "Prestação de contas",
                    status: true,
                    natureza: "SAIDA"
                }
            )
            console.log(response.data)
        } catch (err) {
            console.log(err)
        }
    }

    render() {
        return (
            <CambistaTemplate label="Caixa Cambista">
                <div class="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog"
                    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    {/* <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title font-weight-bolder" id="exampleModalLongTitle">Prestação de
                                        contas</h4>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <input class="form-control" disbled
                                           value={"R$ : " + ((this.state.entradas - this.state.saidas) - this.state.comissao).toFixed(2)}></input>
                                    <button type="button" class="mt-2 btn-fill btn btn-info" data-dismiss="modal">Anexar
                                        comprovante
                                    </button>
                                </div>
                                <div class="modal-footer" style={{justifyContent: 'flex-end'}}>
                                    <button type="button" class="btn-fill btn btn-danger"
                                            onClick={this.criarTransacao}>Confirmar pagamento
                                    </button>
                                </div>
                            </div>
                        </div> */}
                </div>

                <div className="container-fluid">
                    {/* <button type="button" className="mb-2 btn-fill btn btn-primary" data-toggle="modal"
                                data-target="#exampleModalCenter">
                            Prestar contas
                        </button> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="card-title">Caixa da rodada</h4>
                                            <p className="card-category">Informações do caixa.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col font-weight-bold text-success">
                                                Total em vendas: R${(this.state.entradas).toFixed(2)}
                                            </div>
                                            <div className="col font-weight-bold text-warning">
                                                Valor a ser prestado:
                                                R${((this.state.entradas - this.state.saidas) - this.state.comissao).toFixed(2)}
                                            </div>
                                            <div className="col font-weight-bold text-dark">
                                                Sua comissão:
                                                R${this.state.comissao.toFixed(2)}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card strpied-tabled-with-hover">
                                        <div class="card-header ">
                                            <h4 class="card-title">Acompanhe suas movimentações</h4>
                                            <p class="card-category">Informações de movimentações.</p>
                                        </div>
                                        <div class="card-body table-full-width table-responsive">
                                            <table class="table table-hover table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Data</th>
                                                        <th>Tipo</th>
                                                        <th>Comissão R$</th>
                                                        <th>Emissor</th>
                                                        <th>Receptor</th>
                                                        <th>Valor</th>
                                                        <th>Documento</th>
                                                        <th>Observação</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.transacoes != null
                                                        ? this.state.transacoes.map((item) => {

                                                            return (

                                                                <tr
                                                                    class=
                                                                    "font-weight-bold "
                                                                >
                                                                    <td>{this.formatDate(item.data)}</td>
                                                                    <td>{item.tipo}</td>
                                                                    {/* <td>{(item.emissorId._id == this.state.user._id
                                                                        ? 'SAIDA'
                                                                        : "ENTRADA")}</td> */}
                                                                    <td>{item.taxaComissao != null ? item.taxaComissao.toFixed(2) : item.taxaComissao}</td>
                                                                    <td>{item.emissorId.nome}</td>
                                                                    <td>{item.receptorId.nome}</td>
                                                                    <td>
                                                                        {(item.emissorId._id == this.state.user._id)
                                                                            ? "-"
                                                                            : "+" + item.valor}
                                                                    </td>
                                                                    <td>{item.documento}</td>
                                                                    <td>{item.observacao}</td>
                                                                </tr>
                                                            );
                                                        })
                                                        : ""}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CambistaTemplate>
        )
    }
}

export default CaixaCambista
